/*
 * @Author: Ryan
 * @Date: 2026-01-19
 * @Description: Video Showcase Section - 视频展示区块
 */
import { useRouter } from 'next/router';
import React, { useContext } from 'react';

import StartButton from '@/3.0/ai-avatar-generator/seo/StartButton';
import { RightContext } from '@/components/RightProvider/context';

import VideoCarousel, { VideoItem } from '../../common/VideoCarousel';
import styles from './index.module.scss';

export interface VideoShowcaseSectionProps {
  /** 区块标题 */
  title: string;
  /** 区块副标题 */
  subtitle: string;
  /** 视频列表 */
  videos: VideoItem[];
  /** CTA 按钮文本 */
  ctaText: string;
  /** CTA 跳转链接 */
  ctaUrl?: string;
  /** 是否自动播放视频 */
  autoPlay?: boolean;
}

const VideoShowcaseSection: React.FC<VideoShowcaseSectionProps> = ({
  title,
  subtitle,
  videos,
  ctaText,
  ctaUrl = '/ai-video-generator',
  autoPlay = true,
}) => {
  const router = useRouter();
  const rightContext = useContext(RightContext);

  // CTA 点击
  const handleCtaClick = async () => {
    if (!rightContext.getIsLoggedIn()) {
      await rightContext.getUserLoginState({
        onReady: () => {
          router.push(ctaUrl);
        },
      });
      return;
    }
    router.push(ctaUrl);
  };

  return (
    <section className={styles.section}>
      {/* 标题区域 */}
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>
      </div>

      {/* 视频滚动区域 - 全屏宽度 */}
      <div className={styles.carouselWrapper}>
        <VideoCarousel videos={videos} autoPlay={autoPlay} />
      </div>

      {/* CTA 按钮 */}
      <div className={styles.ctaWrapper}>
        <StartButton
          text={ctaText}
          onClick={handleCtaClick}
          className={styles.ctaButton}
        />
      </div>
    </section>
  );
};

export default VideoShowcaseSection;
